var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberTwoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 10C0.833252 4.91667 4.91658 0.833334 9.99992 0.833334C15.0833 0.833334 19.1666 4.91667 19.1666 10C19.1666 15.0833 15.0833 19.1667 9.99992 19.1667C4.91658 19.1667 0.833252 15.0833 0.833252 10ZM2.49992 10C2.49992 14.1667 5.83325 17.5 9.99992 17.5C14.1666 17.5 17.4999 14.1667 17.4999 10C17.4999 5.83333 14.1666 2.5 9.99992 2.5C5.83325 2.5 2.49992 5.83333 2.49992 10Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1391_11200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 0.833334C4.91658 0.833334 0.833252 4.91667 0.833252 10C0.833252 15.0833 4.91658 19.1667 9.99992 19.1667C15.0833 19.1667 19.1666 15.0833 19.1666 10C19.1666 4.91667 15.0833 0.833334 9.99992 0.833334ZM9.99992 17.5C5.83325 17.5 2.49992 14.1667 2.49992 10C2.49992 5.83333 5.83325 2.5 9.99992 2.5C14.1666 2.5 17.4999 5.83333 17.4999 10C17.4999 14.1667 14.1666 17.5 9.99992 17.5ZM9.86325 10.7717C9.43547 11.1839 8.84825 11.7128 8.10158 12.3583L7.26158 13.0817V14.05H12.9316V12.9417H9.23325L9.75825 12.475C10.3649 11.9383 10.8627 11.4678 11.2516 11.0633C11.6483 10.6511 11.9866 10.1883 12.2666 9.675C12.5544 9.15389 12.6983 8.61333 12.6983 8.05333C12.6983 7.27556 12.4571 6.65333 11.9749 6.18667C11.5005 5.72 10.8394 5.48667 9.99158 5.48667C9.20603 5.48667 8.55658 5.72389 8.04325 6.19833C7.5377 6.665 7.27325 7.34167 7.24992 8.22833H8.53325C8.54881 7.73833 8.68103 7.34944 8.92992 7.06167C9.18658 6.76611 9.54436 6.61833 10.0033 6.61833C10.4777 6.61833 10.8238 6.75056 11.0416 7.015C11.2671 7.27944 11.3799 7.645 11.3799 8.11167C11.3799 8.56278 11.236 9.01389 10.9483 9.465C10.6605 9.91611 10.2988 10.3517 9.86325 10.7717Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1391_11200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#161616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwoIcon);
export default __webpack_public_path__ + "static/media/number-two-icon.afbef0d641a7e9a6ccff838c7784dc13.svg";
export { ForwardRef as ReactComponent };